module.exports = __webpack_public_path__ + "img/logox2.b657b27f.png";